import { useMemo } from 'react';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import { formatLocalDate, formatDuration } from '../../utils/dates';
import { BaseChartTable } from '../shared/BaseChartTable';
import { useNidNavigation } from '../../hooks/useNidNavigation';
import { renderCommonCells } from '../shared/chartTableHelpers';

interface InProgressChartTableProps {
  selectedProcessName?: string | null;
  onResetSelection: () => void;
}

export const InProgressChartTable = ({
  selectedProcessName,
  onResetSelection,
}: InProgressChartTableProps) => {
  const { orchestrators } = useOrchestratorList();
  const { handleNidClick } = useNidNavigation();

  const tableData = useMemo(() => {
    const data: Array<{
      nid: string;
      processName: string;
      startDate: string;
      updatedDate: string;
      totalDuration: string;
    }> = [];

    orchestrators.data?.forEach(o => {
      o.workflow_steps.forEach(ws => {
        if (ws.status === 'IN_PROGRESS') {
          if (!selectedProcessName || ws.name === selectedProcessName) {
            data.push({
              nid: o.nid,
              processName: ws.name,
              startDate: formatLocalDate(ws.start_at),
              updatedDate: formatLocalDate(o.updated_at),
              totalDuration: formatDuration(o.start_at, o.updated_at),
            });
          }
        }
      });
    });

    return data;
  }, [orchestrators.data, selectedProcessName]);

  const exportData = useMemo(
    () =>
      tableData.map((item, index) => ({
        'No.': index + 1,
        NID: item.nid,
        'Nombre del Proceso': item.processName,
        'Fecha Inicio': item.startDate,
        'Fecha Actualización': item.updatedDate,
        'Tiempo Total': item.totalDuration,
      })),
    [tableData]
  );

  return (
    <BaseChartTable
      title="Datos de En Progreso"
      data={tableData}
      headers={[
        'No.',
        'NID',
        'Nombre del Proceso',
        'Fecha Inicio',
        'Fecha Actualización',
        'Tiempo Total',
      ]}
      renderRow={(row, index) => (
        <tr key={index}>
          {renderCommonCells(row, index, handleNidClick)}
          <td>{row.startDate}</td>
          <td>{row.updatedDate}</td>
          <td>{row.totalDuration}</td>
        </tr>
      )}
      exportData={exportData}
      exportFilename={`en_progreso_${new Date().toISOString().split('T')[0]}`}
      hasSelection={!!selectedProcessName}
      onResetSelection={onResetSelection}
    />
  );
};
